const fields = {
    name: 'Nazwa',
    surname: 'Nazwisko',
    email: 'Email',
    phone: 'Numer telefonu',
    companyName: 'Nazwa firmy',
    coach: 'Trener',
    coachId: 'Trener',
    coaches: 'Trenerzy',
    coachesIds: 'Trenerzy',
    region: 'Region',
    'region.name': 'Region',
    nip: 'NIP',
    companyNIP: 'NIP',
    regon: 'REGON',
    nrb: 'Numer rachunku bankowego',
    blueMediaId: 'BlueMedia Id',
    blueMediaKey: 'BlueMedia Key',
    birthDate: 'Rok urodzenia',
    birthDateShort: 'Rok ur.',
    height: 'Wzrost (w cm)',
    order: 'Kolejność sortowania',
    lastGroupUpdate: 'Ostatnia zmiana grupy',
    currentAgreementId: 'Aktualna umowa',
    agreementId: 'Umowa',
    postfix: 'Dodatkowe oznaczenie',
    examCode: 'Typ testu',
    examDescriptive: 'Ocena opisowa',
    activeStartDate: 'Data początkowa obowiązywania',
    activeEndDate: 'Data końcowa obowiązywania',

    firstTrainingDate: 'Pierwszy trening',
    lastTrainingDate: 'Ostatni trening',
    season: 'Sezon',

    type: 'Typ',
    typeId: 'Typ',
    amount: 'Kwota',
    age: 'Wiek',

    lastModifiedDate: 'Data ostatniej modyfikacji',
    body: 'Treść',
    validTo: 'Wyświetlaj do',

    DEPRECATED__blockSubscriptions: '[PRZESTARZAŁE] Zablokowane zapisy',
    DEPRECATED__blockAgreements: '[PRZESTARZAŁE] Zablokowane umowy',

    lockSubscriptions: 'Zablokowane zapisy',
    lockAgreements: 'Zablokowane umowy',

    desireToSubscribe: 'Grupa do deklaracji chęci zapisu',

    staffComment: 'Komentarz trenerzy',
    managersComment: 'Notatki',

    privateComment: 'STARE_Notatki',

    additionalInfo: 'Dodatkowe informacje',

    sendEmailsCopies: 'Wysyłaj do mnie kopie e-maili',

    group: 'Grupa',
    groupId: 'Grupa',

    school: 'Szkoła',
    schoolId: 'Szkoła',

    groupsIds: 'Grupy',

    account: 'Konto',
    accountId: 'Konto',

    companyId: 'Firma',

    managersIds: 'Menadżerowie',
    mainManagerId: 'Główny menadżer',

    emailVerified: 'Email potwierdzony',
    deleted: 'Usunięty',

    monthValue: 'Miesiąc',
    monthValueForNextChild: 'Miesiąc kolejne dziecko',
    trainingValue: 'Trening',
    trainingValueForNextChild: 'Trening kolejne dziecko',

    parent: 'Rodzic',
    parentId: 'Rodzic',

    'permissions.admin': 'Admin',
    'permissions.manager': 'Menadżer',
    'permissions.coach': 'Trener',
    'permissions.parent': 'Rodzic',
    child: 'Dziecko',
    childId: 'Dziecko',
    present: 'Obecny',
    sportsWearStorage: 'Przechowywane stroje',
    createdDate: 'Data utworzenia',

    signDate: 'Data podpisania',
    startDate: 'Data rozpoczęcia',
    endDate: 'Data zakończenia',
    cancelDate: 'Data rozwiązania',

    sportsWearReady: 'Wydany trenerowi',
    sportsWearReleased: 'Wydany rodzicowi',

    description: 'Opis',
    active: 'Aktywna',

    cancelReason: 'Powód rozwiązania',
    agreementNumber: 'Numer umowy',
    comment: 'Komentarz',

    bankAccountNumber: 'Numer rachunku bankowego',
    month: 'Miesiąc',
    date: 'Data',
    points: 'Punkty'
};

Object.keys(fields).forEach(key => {
    fields[`metadata.${key}`] = fields[key];
});

const translations = {
    fields,
}

export default translations
